import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { GridColDef } from '@mui/x-data-grid';
import { format } from 'date-fns';
import { TFunction } from 'i18next';

import { StatusChip } from '@/components/Cards/Chips/StatusChip';
import { getBgStatusFF, getLbColorStatusFF } from '@/utils/orders';

interface OrderStatusColumnProps {
  t: TFunction<'commonGeneral', undefined>;
  handleOpenModal: (orderId: string) => void;
  downloadOrder: (orderId: string) => void;
}

export const orderStatusColumns = ({
  t,
  handleOpenModal,
  downloadOrder,
}: OrderStatusColumnProps): Array<GridColDef> => [
  {
    field: 'orderId',
    flex: 1,
    headerName: `Nº de orden`,
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    renderCell: (params) => (
      <Typography
        variant="body2"
        sx={{
          color: (theme) => theme.palette.grey[600],
          mt: '1.9rem',
        }}
      >
        {params.row.orderNumber}
      </Typography>
    ),
  },
  {
    field: 'tracking',
    flex: 1,
    headerName: 'Nº de seguimiento',
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    renderCell: (params) => (
      <Typography
        variant="body2"
        display={'inline'}
        sx={{ fontWeight: 'bold', color: (theme) => theme.palette.grey[600] }}
      >
        {params.row.tracking[0]}
      </Typography>
    ),
  },
  {
    field: 'createAt',
    flex: 1,
    headerName: 'Creación',
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    renderCell: (params) => (
      <Typography
        variant="body2"
        display={'inline'}
        sx={{ fontWeight: 'bold', color: (theme) => theme.palette.grey[600] }}
      >
        {format(new Date(params.row.createdAt), 'dd/MM/yyyy')}
      </Typography>
    ),
  },
  {
    field: 'deliveryType',
    flex: 1,
    headerName: 'Tipo de orden',
    sortable: false,
    align: 'center',
    headerAlign: 'center',
    renderCell: (params) => (
      <Typography
        variant="body2"
        display={'inline'}
        sx={{ fontWeight: 'bold', color: (theme) => theme.palette.grey[600] }}
      >
        {params.row.deliveryType === 'NXD' ? 'SPT' : params.row.deliveryType}
      </Typography>
    ),
  },
  {
    field: 'orderStatus',
    flex: 1,
    headerName: 'Estatus',
    sortable: false,
    align: 'center',
    headerAlign: 'center',
    renderCell: (params) => (
      <StatusChip
        status={t(`fulfillmentStatus.${params.row.fulfillmentStatus}`)}
        bg={getBgStatusFF(params.row.fulfillmentStatus)}
        color={getLbColorStatusFF(params.row.fulfillmentStatus)}
      />
    ),
  },
  {
    field: 'actions',
    flex: 0.5,
    headerName: 'Acciones',
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    resizable: false,
    renderCell: (params) => {
      if (params.row.fulfillmentStatus === 'canceled') {
        return null;
      }
      if (params.row.fulfillmentStatus === 'pending') {
        return (
          <Box>
            <Tooltip title="Cancelar orden">
              <IconButton
                onClick={() => {
                  handleOpenModal(params.row.id);
                }}
              >
                <DeleteOutlineIcon color="secondary" />
              </IconButton>
            </Tooltip>
          </Box>
        );
      } else {
        return (
          <Box>
            <Tooltip title="Descargar orden">
              <IconButton onClick={() => downloadOrder(params.row.id)}>
                <CloudDownloadOutlinedIcon color="primary" />
              </IconButton>
            </Tooltip>
          </Box>
        );
      }
    },
  },
];
